import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { openFile, byteSize, Translate, TextFormat, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDeal } from 'app/shared/model/deal.model';
import { getEntities } from './deal.reducer';

export const Deal = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );

  const dealList = useAppSelector(state => state.deal.entities);
  const loading = useAppSelector(state => state.deal.loading);
  const totalItems = useAppSelector(state => state.deal.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  return (
    <div>
      <h2 id="deal-heading" data-cy="DealHeading">
        <Translate contentKey="activitiesApp.deal.home.title">Deals</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="activitiesApp.deal.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/deal/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="activitiesApp.deal.home.createLabel">Create new Deal</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {dealList && dealList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="activitiesApp.deal.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="activitiesApp.deal.name">Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('startDateTime')}>
                  <Translate contentKey="activitiesApp.deal.startDateTime">Start Date Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('endDateTime')}>
                  <Translate contentKey="activitiesApp.deal.endDateTime">End Date Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('activityType')}>
                  <Translate contentKey="activitiesApp.deal.activityType">Activity Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealCategory')}>
                  <Translate contentKey="activitiesApp.deal.dealCategory">Deal Category</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealImageOne')}>
                  <Translate contentKey="activitiesApp.deal.dealImageOne">Deal Image One</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealImageTwo')}>
                  <Translate contentKey="activitiesApp.deal.dealImageTwo">Deal Image Two</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealImageThree')}>
                  <Translate contentKey="activitiesApp.deal.dealImageThree">Deal Image Three</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealImageOneUrl')}>
                  <Translate contentKey="activitiesApp.deal.dealImageOneUrl">Deal Image One Url</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealImageTwoUrl')}>
                  <Translate contentKey="activitiesApp.deal.dealImageTwoUrl">Deal Image Two Url</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealImageThreeUrl')}>
                  <Translate contentKey="activitiesApp.deal.dealImageThreeUrl">Deal Image Three Url</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealSummary')}>
                  <Translate contentKey="activitiesApp.deal.dealSummary">Deal Summary</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealDescription')}>
                  <Translate contentKey="activitiesApp.deal.dealDescription">Deal Description</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('dealUrl')}>
                  <Translate contentKey="activitiesApp.deal.dealUrl">Deal Url</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="activitiesApp.deal.user">User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="activitiesApp.deal.activity">Activity</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="activitiesApp.deal.city">City</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dealList.map((deal, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/deal/${deal.id}`} color="link" size="sm">
                      {deal.id}
                    </Button>
                  </td>
                  <td>{deal.name}</td>
                  <td>{deal.startDateTime ? <TextFormat type="date" value={deal.startDateTime} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{deal.endDateTime ? <TextFormat type="date" value={deal.endDateTime} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>
                    <Translate contentKey={`activitiesApp.ActivityType.${deal.activityType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`activitiesApp.DealCategory.${deal.dealCategory}`} />
                  </td>
                  <td>
                    {deal.dealImageOne ? (
                      <div>
                        {deal.dealImageOneContentType ? (
                          <a onClick={openFile(deal.dealImageOneContentType, deal.dealImageOne)}>
                            <img src={`data:${deal.dealImageOneContentType};base64,${deal.dealImageOne}`} style={{ maxHeight: '30px' }} />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {deal.dealImageOneContentType}, {byteSize(deal.dealImageOne)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {deal.dealImageTwo ? (
                      <div>
                        {deal.dealImageTwoContentType ? (
                          <a onClick={openFile(deal.dealImageTwoContentType, deal.dealImageTwo)}>
                            <img src={`data:${deal.dealImageTwoContentType};base64,${deal.dealImageTwo}`} style={{ maxHeight: '30px' }} />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {deal.dealImageTwoContentType}, {byteSize(deal.dealImageTwo)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {deal.dealImageThree ? (
                      <div>
                        {deal.dealImageThreeContentType ? (
                          <a onClick={openFile(deal.dealImageThreeContentType, deal.dealImageThree)}>
                            <img
                              src={`data:${deal.dealImageThreeContentType};base64,${deal.dealImageThree}`}
                              style={{ maxHeight: '30px' }}
                            />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {deal.dealImageThreeContentType}, {byteSize(deal.dealImageThree)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{deal.dealImageOneUrl}</td>
                  <td>{deal.dealImageTwoUrl}</td>
                  <td>{deal.dealImageThreeUrl}</td>
                  <td>{deal.dealSummary}</td>
                  <td>{deal.dealDescription}</td>
                  <td>{deal.dealUrl}</td>
                  <td>{deal.user ? deal.user.login : ''}</td>
                  <td>{deal.activity ? <Link to={`/activity/${deal.activity.id}`}>{deal.activity.name}</Link> : ''}</td>
                  <td>{deal.city ? <Link to={`/city/${deal.city.id}`}>{deal.city.cityName}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/deal/${deal.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/deal/${deal.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/deal/${deal.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="activitiesApp.deal.home.notFound">No Deals found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={dealList && dealList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Deal;
